exports.onClientEntry = () => {
  const savedTheme = window.localStorage.getItem("theme")
  const theme =
    savedTheme === "light" || savedTheme === "dark"
      ? savedTheme
      : window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"

  document.body.classList.remove("light", "dark")
  document.body.classList.add(theme)
}
